






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import "select2";
import "select2/dist/css/select2.min.css";
declare var $: any;

@Component({
  name: "qSelect2",
  components: {},
  directives: {},
})
export default class qSelect2 extends Vue {
  @Prop()
  value;
  @Prop({
    default: () => {
      return [];
    },
  })
  options: [];
  @Prop({
    default: () => {
      return {};
    },
  })
  config: {};

  mounted() {
    const self = this;
    const setting = { data: this.options, ...this.config };
    $(this.$el)
      // init select2
      .select2(setting)
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on("select2:select", function (e) {
        const data = e.params.data;
        self.$emit("selected", data.text);
        self.$emit("input", data.id);
      });
  }

  destroyed() {
    $(this.$el).off().select2("destroy");
  }

  @Watch("value")
  updateValue(value) {
    // update value
    $(this.$el).val(value).trigger("change");
    this.$emit("change");
  }

  @Watch("options")
  updateOptions(value) {
    // update value
    const setting = { width: "400px", data: value, ...this.config };
    $(this.$el).empty().select2(setting);
    $(this.$el).val(this.value).trigger("change");
  }
}
